import { render, staticRenderFns } from "./PaginatedAutocomplete.vue?vue&type=template&id=4b555cd6&scoped=true&"
import script from "./PaginatedAutocomplete.vue?vue&type=script&lang=js&"
export * from "./PaginatedAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b555cd6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VBtn,VCol})
